import { apiPath } from "./apiClient";

let insightsApiReady = null;
let insightsApiCheckedAt = 0;
const CACHE_MS = 60000;

/**
 * Returns true only when the live backend exposes insight/auth routes (not the legacy photos-only deploy).
 */
export async function isInsightsApiAvailable(force = false) {
  const now = Date.now();
  if (!force && insightsApiReady !== null && now - insightsApiCheckedAt < CACHE_MS) {
    return insightsApiReady;
  }

  try {
    const res = await fetch(apiPath("/api/health"), {
      method: "GET",
      cache: "no-store",
    });
    insightsApiReady = res.ok;
  } catch {
    insightsApiReady = false;
  }
  insightsApiCheckedAt = now;
  return insightsApiReady;
}

export function isStaticHostedSite() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host.includes("triothoughtsolution.com");
}
